import React from 'react';
import { CompetitionStatusTile } from '../CompetitionStatusTile/CompetitionStatusTile';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';
import { ContentfulCompetition } from '@jbhi-fi/apis/src/contentful/types';
import { LoadingSkeleton } from '@jbhi-fi/components/src/LoadingSkeleton/LoadingSkeleton';
import {
  ContentfulFilter,
  useContentfulEntries,
} from '@jbhi-fi/components/src/hooks/useContentfulEntries/useContentfulEntries';
import { styles } from './CompetitionStatusGrid.css';
import { CompetitionTransformer } from '../Contentful/transformers/CompetitionTransformer';

export type CompetitionGridFilter = Omit<ContentfulFilter, 'content_type'>;

export type CompetitionStatusGridProps = {
  filter: CompetitionGridFilter;
  className?: string;
};

export const CompetitionStatusGrid: React.FC<CompetitionStatusGridProps> = ({ filter, className }) => {
  const { entries, isLoading } = useContentfulEntries<ContentfulCompetition>({
    filter: { content_type: 'competition', ...filter },
    count: 50,
  });

  return (
    <div className={classNames([styles.competitionsGrid, className])}>
      {isLoading
        ? Array(6)
            .fill(null)
            .map((_, i) => <LoadingSkeleton.Box key={i} width="100%" />)
        : entries?.map((comp, i) => (
            <CompetitionStatusTile {...CompetitionTransformer.toCompetitionStatusTileProps(comp)} key={i} />
          ))}
    </div>
  );
};
